import { App, createApp } from 'vue';
import { Calendar, DatePicker, setupCalendar } from 'v-calendar';
import 'v-calendar/style.css';
import CalendarComponent from "@/app/calendar/Calendar.vue";
import { CalendarConfiguration } from "@/domain/search/entitites/calendar/calendar-configuration.interface";
import { CalendarMountEvent } from '@/domain/search/entitites/calendar/calendar-mount-event.interface';
import { TranslationService } from "webshop-modules";

let app: App<Element> | null = null;

const initializeApp = (configuration: CalendarConfiguration) => {
    app = createApp(CalendarComponent);
    app.use(setupCalendar, {
        locales: {
            [TranslationService.getLocale()]: {
                firstDayOfWeek: 2,
                masks: {
                    L: 'YYYY-MM-DD',
                }
            }
        }
    });

    const updatedConfiguration = {...configuration, locale: TranslationService.getLocale()};
    app.component('VCalendar', Calendar)
    app.component('VDatePicker', DatePicker)
    app.provide('configuration', updatedConfiguration);
}

const clearAppInstance = () => {
    app = null;
}

window.addEventListener('mountCalendar', (e) => {
    const typedEvent = e as CalendarMountEvent;

    if (app && typedEvent.detail.shouldUnmount) {
        app.unmount();
        clearAppInstance();
    }

    initializeApp(typedEvent.detail);

    if (app) {
        app.mount('#calendar-app');
    }
});

